/* eslint-disable */
import { useEffect, useMemo, useState } from "react";
import {
    Button, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue,
    Icon,
    Stack,
    useToast,
    IconButton
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';
// Custom components   
import { MdChevronRight, MdChevronLeft } from "react-icons/md";
// Assets  
import { SearchBar } from "../../../../components/navbar/searchBar/SearchBar";
import Card from '../../../../components/card/Card';

import {
    createColumnHelper,
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getFacetedRowModel,
    getFacetedUniqueValues,
    getFacetedMinMaxValues,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from '@tanstack/react-table'
import { getCarrierLuggages, updateLuggageStatus } from "../hooks";
import { LoadingSpinner } from "../../../../constants/helper";
import DeliverLuggage from "./DeliverLuggage";
import ViewLuggage from "./ViewLuggage";

export default function CarrierLuggages() {
    const textColor = useColorModeValue("navy.700", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
    const brandColor = useColorModeValue("brand.500", "brand.400");
    const toast = useToast();
    const [loading, setLoading] = useState(true); // Loading state to track fetching status

    const [tableData, setTableData] = useState([]); // Ensure default state is an array
    let defaultData = tableData;
    const [data, setData] = useState(() => [...defaultData]);
    const [luggageId, setLuggageId] = useState("");
    const [openCreateAccess, setOpenCreateAccess] = useState(false);
    const [openViewLuggagage, setOpenViewLuggagage] = useState(false);
    const [fetchApi, setFetchApi] = useState(false);

    const fetchLuggages = async () => {
        setLoading(true);
        try {
            let res = await getCarrierLuggages();
            if (res.success) {
                let luggages = res.data;
                // Transform the response if needed
                const transformedData = luggages.map(luggage => ({
                    ...luggage,
                    actions: {
                        id: luggage.id,
                        status: luggage.luggageStatus
                    } // Assuming ID is used for actions
                }));
                setTableData(transformedData);
                setData(transformedData);
            }
        } catch (error) {
            console.error("Error fetching luggages:", error);
        } finally {
            setLoading(false); // Set loading to false after fetching is complete
        }
    };

    useEffect(() => {
        fetchLuggages(); // Call the async function
    }, [fetchApi]);

    const [columnFilters, setColumnFilters] = useState([])
    const [globalFilter, setGlobalFilter] = useState('')
    const columnHelper = createColumnHelper();
    const columns = [
        columnHelper.accessor('referenceNumber', {
            id: 'referenceNumber',
            header: () => (
                <Text
                    justifyContent='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Reference Number
                </Text>
            ),
            cell: (info) => (
                <Flex align='center'>
                    <Text
                        color={textColor}
                        fontSize='md'
                        fontWeight='500'>
                        {info.getValue()}
                    </Text>
                </Flex>
            )
        }),
        columnHelper.accessor('noOfBags', {
            id: 'noOfBags',
            header: () => (
                <Text
                    justifyContent='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    No. Of Bags
                </Text>
            ),
            cell: (info) => (
                <Text color={textColor} fontSize='md' fontWeight='500'>
                    {info.getValue()}
                </Text>
            )
        }),
        columnHelper.accessor('customerName', {
            id: 'customerName',
            header: () => (
                <Text
                    justifyContent='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Customer Name
                </Text>
            ),
            cell: (info) => (
                <Text color={textColor} fontSize='md' fontWeight='500'>
                    {info.getValue()}
                </Text>
            )
        }),
        columnHelper.accessor('customerPhoneNumber', {
            id: 'customerPhoneNumber',
            header: () => (
                <Text
                    justifyContent='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    Customer PhoneNumber
                </Text>
            ),
            cell: (info) => (
                <Text color={textColor} fontSize='md' fontWeight='500'>
                    {info.getValue()}
                </Text>
            )
        }),
        columnHelper.accessor('actions', {
            id: 'actions',
            header: () => (
                <Text
                    justifyContent='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.400'>
                    ACTIONS
                </Text>
            ),
            cell: (info) => {
                const value = info.getValue(); // Assuming 'actions' holds the user ID
                console.log("Value", value);
                return (
                    value?.status === "Dispatched" ?
                        <Button
                            variant="darkBrand"
                            fontSize="xs"
                            borderRadius="16px"
                            w={{ base: '138px', md: '158px' }}
                            h="46px"
                            ms="auto"
                            onClick={() => handleChangeStatus(value.id, "InTransit")}
                        >
                            Mark as Out for Delivery
                        </Button> : 
                        value?.status === "Delivered" || value?.status === "Cancelled" ?
                        <Button
                            variant="darkBrand"
                            fontSize="xs"
                            borderRadius="16px"
                            w={{ base: '88px', md: '108px' }}
                            h="46px"
                            ms="auto"
                            onClick={() => handleView(value.id)}
                        >
                            View
                        </Button>
                        :
                        <Button
                            variant="darkBrand"
                            fontSize="xs"
                            borderRadius="16px"
                            w={{ base: '108px', md: '128px' }}
                            h="46px"
                            ms="auto"
                            onClick={() => handleDeliver(value.id)}
                        >
                            Deliver Luggage
                        </Button>
                );
            },
        })

    ];
    const [{ pageIndex, pageSize }, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    })

    const pagination = useMemo(
        () => ({
            pageIndex,
            pageSize,
        }),
        [pageIndex, pageSize]
    )
    const table = useReactTable({
        data,
        columns,
        state: {
            columnFilters,
            globalFilter,
            pagination,
        },
        onPaginationChange: setPagination,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getFacetedRowModel: getFacetedRowModel(),
        getFacetedUniqueValues: getFacetedUniqueValues(),
        getFacetedMinMaxValues: getFacetedMinMaxValues(),
        debugTable: true,
        debugHeaders: true,
        debugColumns: false,
    })
    const createPages = (count) => {
        let arrPageCount = [];

        for (let i = 1; i <= count; i++) {
            arrPageCount.push(i);
        }

        return arrPageCount;
    };

    useEffect(() => {
        if (table.getState().columnFilters[0]?.id === 'fullName') {
            if (table.getState().sorting[0]?.id !== 'fullName') {
                table.setSorting([{ id: 'fullName', desc: false }])
            }
        }
    }, [table.getState().columnFilters[0]?.id]);

    const handleDeliver = async (luggageId) => {
        setLuggageId(luggageId);  
        setOpenCreateAccess(true);
    };

    const handleView = async (luggageId) => {
        setLuggageId(luggageId);  
        setOpenViewLuggagage(true);
    };

    const handleChangeStatus = async (luggageId, status) => {
        const model = {
            luggageId: luggageId,
            luggageStatus: status
        };

        const response = await updateLuggageStatus(model);
        if (response.success) {
            toast({
                title: "Luggage status updated successfully.",
                description: response.message,
                status: "success",
                duration: 5000,
                isClosable: true,
                position: "top-right",
            });
            // Optionally refresh data
            fetchLuggages(); // Call your data fetching function
        } else {
            toast({
                title: "Error in luggage status update",
                description: response.message,
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top-right",
            });
        }
    };

    const props = {
        setOpenCreateAccess,
        openCreateAccess,
        luggageId,
        setFetchApi,
    }
    const viewProps = {
        setOpenViewLuggagage,
        openViewLuggagage,
        luggageId,
    }
    return (
        <>
            { openCreateAccess ? <DeliverLuggage {...props} /> : null}
            { openViewLuggagage ? <ViewLuggage {...viewProps} /> : null}
            {
                loading ?
                    <LoadingSpinner />
                    :
                    <Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>
                        <Card px='0px'>
                            <Flex
                                direction='column'
                                w='100%'
                                overflowX={{ sm: "scroll", lg: "hidden" }}>
                                <Flex
                                    align={{ sm: "flex-start", lg: "flex-start" }}
                                    justify={{ sm: "flex-start", lg: "flex-start" }}
                                    w='100%'
                                    px='22px'
                                    mb='36px'>
                                    <DebouncedInput
                                        value={globalFilter ?? ''}
                                        onChange={value => setGlobalFilter(String(value))}
                                        className="p-2 font-lg shadow border border-block"
                                        placeholder="Search..."
                                    />
                                </Flex>
                                <Table variant='simple' color='gray.500' mb='24px'>
                                    <Thead>
                                        {table.getHeaderGroups().map(headerGroup => (
                                            <Tr key={headerGroup.id}>
                                                {headerGroup.headers.map(header => {
                                                    return (
                                                        <Th
                                                            pe='10px'
                                                            borderColor={borderColor} key={header.id} colSpan={header.colSpan}>
                                                            {header.isPlaceholder ? null : (
                                                                <Flex
                                                                    {...{
                                                                        className: header.column.getCanSort()
                                                                            ? 'cursor-pointer select-none'
                                                                            : '',
                                                                        onClick: header.column.getToggleSortingHandler(),
                                                                    }}
                                                                    justify='space-between'
                                                                    align='center'
                                                                    fontSize={{ sm: "10px", lg: "12px" }}
                                                                    color='gray.400'>
                                                                    {flexRender(
                                                                        header.column.columnDef.header,
                                                                        header.getContext()
                                                                    )}
                                                                    {{
                                                                        asc: '',
                                                                        desc: '',
                                                                    }[header.column.getIsSorted()] ?? null}
                                                                </Flex>
                                                            )}
                                                        </Th>
                                                    )
                                                })}
                                            </Tr>
                                        ))}
                                    </Thead>
                                    <Tbody>
                                        {table.getRowModel().rows.map(row => {
                                            return (
                                                <Tr px="20px" key={row.id}>
                                                    {row.getVisibleCells().map(cell => {
                                                        return (
                                                            <Td key={cell.id}
                                                                fontSize={{ sm: "14px" }}
                                                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                                                                borderColor={borderColor}>
                                                                {flexRender(
                                                                    cell.column.columnDef.cell,
                                                                    cell.getContext()
                                                                )}
                                                            </Td>
                                                        )
                                                    })}
                                                </Tr>
                                            )
                                        })}
                                    </Tbody>
                                </Table>
                                <Flex w="100%" justify="space-between" px="20px" pt="10px" pb="5px">
                                    {/* SET ROW NUMBER */}
                                    <Text
                                        fontSize='sm'
                                        color='gray.500'
                                        fontWeight='normal'
                                        mb={{ sm: "24px", md: "0px" }}>
                                        Showing {pageSize * pageIndex + 1} to{" "}
                                        {pageSize * (pageIndex + 1) <= tableData.length
                                            ? pageSize * (pageIndex + 1)
                                            : tableData.length}{" "}
                                        of {tableData.length} entries
                                    </Text>
                                    {/* PAGINATION BUTTONS */}
                                    <div className="flex items-center gap-2">
                                        <Stack direction='row' alignSelf='flex-end' spacing='4px' ms='auto'>
                                            <Button
                                                variant='no-effects'
                                                onClick={() => table.previousPage()}
                                                disabled={!table.getCanPreviousPage()}
                                                transition='all .5s ease'
                                                w='40px'
                                                h='40px'
                                                borderRadius='50%'
                                                bg='transparent'
                                                border='1px solid'
                                                borderColor={useColorModeValue("gray.200", "white")}
                                                display={
                                                    pageSize === 5 ? "none" : table.getCanPreviousPage() ? "flex" : "none"
                                                }
                                                _hover={{
                                                    bg: "whiteAlpha.100",
                                                    opacity: "0.7",
                                                }}>
                                                <Icon as={MdChevronLeft} w='16px' h='16px' color={textColor} />
                                            </Button>
                                            {createPages(table.getPageCount()).map((pageNumber, index) => {
                                                return (
                                                    <Button
                                                        variant='no-effects'
                                                        transition='all .5s ease'
                                                        onClick={() => table.setPageIndex(pageNumber - 1)}
                                                        w='40px'
                                                        h='40px'
                                                        borderRadius='50%'
                                                        bg={
                                                            pageNumber === pageIndex + 1 ? brandColor : "transparent"
                                                        }
                                                        border={
                                                            pageNumber === pageIndex + 1
                                                                ? "none"
                                                                : "1px solid lightgray"
                                                        }
                                                        _hover={
                                                            pageNumber === pageIndex + 1
                                                                ? {
                                                                    opacity: "0.7",
                                                                }
                                                                : {
                                                                    bg: "whiteAlpha.100",
                                                                }
                                                        }
                                                        key={index}>
                                                        <Text
                                                            fontSize='sm'
                                                            color={pageNumber === pageIndex + 1 ? "#fff" : textColor}>
                                                            {pageNumber}
                                                        </Text>
                                                    </Button>
                                                );
                                            })}
                                            <Button
                                                variant='no-effects'
                                                onClick={() => table.nextPage()}
                                                disabled={!table.getCanNextPage()}
                                                transition='all .5s ease'
                                                w='40px'
                                                h='40px'
                                                borderRadius='50%'
                                                bg='transparent'
                                                border='1px solid'
                                                borderColor={useColorModeValue("gray.200", "white")}
                                                display={pageSize === 5 ? "none" : table.getCanNextPage() ? "flex" : "none"}
                                                _hover={{
                                                    bg: "whiteAlpha.100",
                                                    opacity: "0.7",
                                                }}>
                                                <Icon as={MdChevronRight} w='16px' h='16px' color={textColor} />
                                            </Button>
                                        </Stack>
                                    </div>
                                </Flex>
                            </Flex>
                        </Card>
                    </Flex>
            }
        </>
    );
}

// A debounced input react component
function DebouncedInput({
    value: initialValue,
    onChange,
    debounce = 500,
    ...props
}) {
    const [value, setValue] = useState(initialValue)

    useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, debounce)

        return () => clearTimeout(timeout)
    }, [value])

    return (
        <SearchBar
            {...props}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            h='44px'
            w={{ lg: "390px" }}
            borderRadius='16px'
        />
    )
}
